import { UserGroupRequest } from '@cdaas/api-clients/dist/asset-user-openapi';

import { UserGroup } from '../types';

export const convertUserGroupToUserGroupRequest = (userGroup: UserGroup): UserGroupRequest => {
  return {
    ...userGroup,
    invoicing_account: userGroup.invoicing_account?.id,
  };
};
